import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

interface ISettingsIconProps extends Pick<
  IProps,
  'size' | 'color' | 'className'
> {
  active?: boolean;
}

const SettingsIcon = ({
  color = colors.black,
  className,
  size = 16,
  active = false,
}: ISettingsIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.27299 6.72741C9.97594 7.43035 9.97594 8.57005 9.27299 9.27299C8.57005 9.97594 7.43035 9.97594 6.72741 9.27299C6.02446 8.57005 6.02446 7.43035 6.72741 6.72741C7.43035 6.02446 8.57005 6.02446 9.27299 6.72741"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.50024 8C3.50024 8.198 3.51824 8.396 3.54224 8.588L2.48357 9.416C2.24891 9.6 2.18491 9.92867 2.33424 10.1867L3.27557 11.8153C3.42424 12.0733 3.74024 12.182 4.01691 12.0713L4.96491 11.6907C5.15224 11.6153 5.36091 11.6453 5.52891 11.7567C5.67557 11.854 5.82757 11.9433 5.98491 12.0233C6.16491 12.1147 6.29557 12.278 6.32424 12.478L6.46891 13.4867C6.51091 13.7813 6.76357 14 7.06091 14H8.93891C9.23624 14 9.48891 13.7813 9.53091 13.4867L9.67557 12.4787C9.70424 12.2787 9.83624 12.114 10.0169 12.0233C10.1736 11.9447 10.3249 11.856 10.4709 11.7593C10.6402 11.6473 10.8496 11.6153 11.0376 11.6913L11.9836 12.0713C12.2596 12.182 12.5756 12.0733 12.7249 11.8153L13.6662 10.1867C13.8156 9.92867 13.7516 9.59933 13.5169 9.416L12.4582 8.588C12.4822 8.396 12.5002 8.198 12.5002 8C12.5002 7.802 12.4822 7.604 12.4582 7.412L13.5169 6.584C13.7516 6.4 13.8156 6.07133 13.6662 5.81333L12.7249 4.18467C12.5762 3.92667 12.2602 3.818 11.9836 3.92867L11.0376 4.30867C10.8496 4.384 10.6402 4.35267 10.4709 4.24067C10.3249 4.144 10.1736 4.05533 10.0169 3.97667C9.83624 3.886 9.70424 3.72133 9.67557 3.52133L9.53157 2.51333C9.48957 2.21867 9.23691 2 8.93957 2H7.06157C6.76424 2 6.51157 2.21867 6.46957 2.51333L6.32424 3.52267C6.29557 3.722 6.16424 3.886 5.98491 3.97733C5.82757 4.05733 5.67557 4.14733 5.52891 4.244C5.36024 4.35467 5.15157 4.38467 4.96424 4.30933L4.01691 3.92867C3.74024 3.818 3.42424 3.92667 3.27557 4.18467L2.33424 5.81333C2.18491 6.07133 2.24891 6.40067 2.48357 6.584L3.54224 7.412C3.51824 7.604 3.50024 7.802 3.50024 8V8Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {active && (
        <rect
          x="9.66667"
          y="1.66667"
          width="5.66667"
          height="5.66667"
          rx="2.83333"
          fill="#1EBAB2"
          stroke="white"
          strokeWidth="0.666667"
        />
      )}
    </svg>
  );
};

export default SettingsIcon;
